// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__NFNdc","btn1":"button_btn1__vNObY","btn2":"button_btn2__sopmq","btn3":"button_btn3__ZZNX8","btn4":"button_btn4__PMknk","btn5":"button_btn5__UweI2"};